import { Button, Space } from "antd";
import { NavLink } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

export const getHeaderColumns = (t, module, goTo, expandedRows = []) => [
  {
    title: t('Document'),
    dataIndex: 'name',
    key: 'name',
    show: true,
    sorter: (a, b) => ('' + a.name).localeCompare(b.name),
    render: (name, item, index) => {
      const par = expandedRows.find((s) => s.key === item.key);
      return (
        <>
          {(par && par.children && !item.children) && (
            <>
              <div
                style={{
                  position: 'absolute',
                  left: 15,
                  width: 1,
                  top: 0,
                  height: index === par.children.length - 1 ? '50%' : '100%',
                  background: '#B5B5B5',
                }}
              />
              <div
                style={{
                  position: 'absolute',
                  left: 15,
                  height: 1,
                  width: 20,
                  top: '50%',
                  background: '#B5B5B5',
                }}
              />
            </>
          )}
          <NavLink className="projectLink" to={`/app/${module}/view${item.id !== 'kyc' ? 'dd' : ''}/${item.id}/${item.datastakeId}?version=${item.version}`}>
            {name}
          </NavLink>
        </>
      )
    },
  },
  {
    title: t('Author'),
    dataIndex: 'author',
    defaultSortOrder: 'ascend',
    sorter: (a, b) => ('' + a.author).localeCompare(b.author),
    key: 'author',
    show: true,
  },
  {
    title: t('Date'),
    dataIndex: 'lastUpdated',
    key: 'lastUpdated',
    show: true,
  },
  {
    title: t('Actions'),
    key: 'action',
    show: true,
    render: (item) => {
      return <Space style={{ width: 'fit-content' }}>
        <Button
          type="primary"
          size="small"
          className="no-ln-height"
          icon={<EyeOutlined />}
          onClick={() => {
            goTo(`/app/${module}/view${item.id !== 'kyc' ? 'dd' : ''}/${item.id}/${item.datastakeId}?version=${item.version}`)
          }}>{t('View')}</Button>
      </Space>
    },
  },
]

export const selectFiltersConfig = {
  author: {
    type: 'text',
    label: 'Author',
    placeholder: (t) => `${t('Filter by')} ${t('Author').toLowerCase()}`,
    style: { width: 200 },
    labelStyle: { maxWidth: 200 },
  },
};

export const filtersConfig = {
  name: '',
  datastakeId: '',
};

export const checkboxConfig = {
  name: 'Name',
  datastakeId: 'ID',
};

export const selectOptions = {};

export const mstp = ({
  authentication, project
}) => ({ authentication, project });
